<template>
    <section class="hero privacy-hero is-hidden-mobile is-hidden-tablet-only is-hidden-desktop-only">
        <div class="hero-body">
            <section class="section">
                <div class="container">
                </div>
            </section>
        </div>
    </section>

    <section class="is-hidden-widescreen">
        <img src="https://assets.webbank.com/718.png">
    </section>

    <section class="section">
        <div class="container">
            <div class="columns">
                <div class="column is-8 is-offset-2">
                    <div class="content">
            <span id="start">&nbsp;</span>
            <br>
            <h2 class="is-size-1 hero-title has-text-primary">WebBank Website Visitors Privacy Policy</h2>

            <p>This privacy policy applies to consumers that visit our website at https://www.webbank.com/. Your privacy is important to us. In this privacy policy, we explain how we collect, share, use, and protect your information.</p>
            <br>
            <h4 class="pp-section-title">Types of Information We Collect and Sources</h4>
            <br>
            <p>The following are examples of the types of information we collect and the sources:</p>
            <ul>
                <li>Your IP address, the type of operating system and browser you use, the identity of any website you came from, and the site you visit next. We may use cookies, web beacons or other technologies to collect and store this information.</li>
            </ul>
            <br>
            <h4 class="pp-section-title">Use of Information</h4>
            <br>
            <p>We use the information discussed above in a number of ways, such as:</p>
            <ul>
                <li>Operating, evaluating and improving our business (including developing new products and services; improving existing products and services; performing data analytics; and performing accounting, auditing and other internal functions); and Responding to your requests and communicating with you.</li>
            </ul>
            <br>
            <h4 class="pp-section-title">Disclosure of Information</h4>
            <br>
            <p>We may share the information we collect from and about you:</p>
            <ul>
                <li>With WebBank's third-party service providers;</li>
                <li>With third parties or affiliates in connection with a corporate transaction, such as a sale, consolidation or merger of WebBank businesses;</li>
                <li>With other third parties to comply with legal requirements such as the demands of applicable subpoenas and court orders; to verify or enforce our terms of use, our other rights, or other applicable policies; to address fraud, security or technical issues; to respond to an emergency; or otherwise to protect the rights, property or security of our customers or third parties; and</li>
                <li>With third parties in an anonymous or aggregated manner to help deliver products, services, and content that are tailored to you and for other purposes.</li>
            </ul>
            <br>
            <h4 class="pp-section-title">Understanding Cookies, Web Beacons and Other Tracking Technologies</h4>
            <br>
            <p>We, may deploy and use cookies, web beacons, local shared objects and other tracking technologies for various purposes, such as fraud prevention and monitoring our advertising and marketing campaign performance. Some of these tracking tools may detect characteristics or settings of the specific device you use to access our website.</p>
            <br>
            <p>“Cookies” are small amounts of data a website can send to a visitor's web browser. They are often stored on the device you are using to help track You areas of interest. Cookies may also enable us, our service providers, and other companies we work with to relate your use of our online services over time to customize your online experience. Most web browsers allow you to adjust your browser settings to decline or delete cookies but doing so may degrade your experience with our website.</p>
            <br>
            <p>Clear GIFs, pixel tags or web beacons—which are typically one-pixel, transparent images located on a webpage or in an email or other message—or similar technologies may be used on our sites and in some of our digital communications (such as email or other marketing messages). They may also be used when you are served advertisements. These are principally used to help recognize users, assess traffic patterns and measure site or campaign engagement.</p>
            <br>
            <p>Local Shared Objects, sometimes referred to as “flash cookies” may be stored on your hard drive using a media player or other software installed on your device. Local Shared Objects are similar to cookies in terms of their operation but may not be managed in your browser in the same way.</p>
            <br>
            <h4 class="pp-section-title">Do Not Track</h4>
            <br>
            <p>Many web browsers possess a do-not-track feature that lets your browser tell websites you visit that you do not want to have your online activities tracked. At this time, our website does not respond to browser do-not-track signals.</p>
            <br>
            <h4 class="pp-section-title">Linking to Third-Party Websites</h4>
            <br>
            <p>WebBank may provide links to websites that are owned or operated by others ("third-party websites"). When you use a link online to visit a third-party website, you will be subject to that website's privacy and security practices, which may differ from ours. You should familiarize yourself with the privacy notice/policy, terms of use and security practices of the linked third-party website before providing any information on that website.</p>
            <br>
            <h4 class="pp-section-title">Security</h4>
            <br>
            <p>To protect your personal information from unauthorized access and use, we use reasonable electronic and procedural safeguards to protect and limit access to personal information.</p>
            <br>
            <h4 class="pp-section-title">Minors</h4>
            <br>
            <p>Our website is not intended for persons under 18 years of age. We do not knowingly collect personal information from persons under 18 years of age.</p>
            <br>
            <h4 class="pp-section-title">Accessing Our Website from Outside the U.S</h4>
            <br>
            <p>Our website is intended for a U.S. audience. If you visit our website, your information will be transferred to or processed in the United States.</p>
            <br>
            <h4 class="pp-section-title">Questions</h4>
            <a name="ca-link" id="section-ca-privacy">&nbsp;</a>
            <p>If you have questions about our privacy practices, please contact us at 1-844-994 BANK (2265).</p>
            <br>
            <h4 class="pp-section-title">California Privacy Notice</h4>
            <br>
            <p>If you are a California resident who is a natural person, the California Consumer Privacy Act (“CCPA”) provides certain rights concerning your personal information, unless an exception applies. In addition to certain exceptions, the CCPA does not consider information to be personal information if it cannot be reasonably linked to any consumer or household.</p>
            <br>
            <p>If you are a consumer that visits our website, information collected by WebBank is not considered personal information under the CCPA as it cannot be linked, or could not be reasonably linked, to any consumer or household, and, therefore, the CCPA does not apply.</p>
            <br>
            <h4 class="pp-title has-text-primary">WebBank Individuals at Other Businesses Privacy Policy</h4>
            <br>
            <p>This privacy policy governs WebBank's collection and use of personal information about individuals associated with third-party businesses, including owners, directors, officers, and employees at current, former, and prospective Brand Partners. WebBank does not and will not sell such information to third parties.</p>
            <br>
            <h4 class="pp-section-title">Questions</h4>
            <br>
            <p>If you have questions about our privacy practices, please contact us at 1-844-994 BANK (2265).</p>
            <br>
            <h4 class="pp-section-title">California Privacy Notice</h4>
            <br>
            <p>If you are a California resident who is a natural person, the California Consumer Privacy Act (“CCPA”) provides certain rights concerning your personal information unless an exception applies. These exceptions include information collected in the course of a business-to-business transaction or activity about individuals associated with another business, so long as such information is not sold to a third party (the “Business-to-Business exception”). As noted above, WebBank does not and will not sell personal information about California natural persons associated with third-party businesses, and, therefore, the CCPA does not apply.</p>
            <br>
            <h4 class="pp-title has-text-primary">WebBank Online Deposit Privacy Policy</h4>
            <br>
            <p>This privacy policy governs WebBank's online deposit program. It applies to current or former online deposit customers and applicants as well as consumers that interact or view one of our digital advertising campaigns for the online deposit program. Your privacy is important to us. In this privacy policy, we explain how we collect, share, use, and protect your information. Our information collection and sharing practices are further described in our [Online Deposit Privacy Notice].</p>
            <br>
            <h4 class="pp-section-title">Types of Information We Collect and Sources</h4>
            <br>
            <p>The following are examples of the types of information we collect and the sources:</p>
            <ul>
                <li>Information you provide in connection with your deposit account application, including your name, email address, mailing address, telephone number(s), deposit account numbers, social security number, and driver's license number (or comparable identification number);
    Consumer reports from Consumer Reporting Agencies pursuant to the Fair Credit Reporting Act in connection with an application;
    Information from other third parties concerning your identity and information related to preventing fraud;
    Account information; and Your IP address, the type of operating system and browser you use, the identity of any website you came from, and the site you visit next. We may use cookies, web beacons or other technologies to collect and store this information.
                </li>
            </ul>
            <br>
            <h4 class="pp-section-title">Use of Information</h4>
            <p>We use the information discussed above in a number of ways, such as:</p>
            <ul>
                <li>Processing your online deposit application;</li>
                <li>Processing transactions;</li>
                <li>Verifying your identity (such as when you access your account);</li>
                <li>Preventing and reporting fraud;</li>
                <li>Enhancing the security of your online deposit account and our online deposit services;</li>
                <li>Responding to your requests and communicating with you;</li>
                <li>Managing your online deposit account preferences;</li>
                <li>Performing analytics concerning your online deposit account;</li>
                <li>Performing analytics concerning our marketing, including your responses to our emails and the pages and advertisements you view;</li>
                <li>Providing you tailored content and marketing messages;</li>
                <li>Operating, evaluating and improving our business (including developing new products and services; improving existing products and services; performing data analytics; and performing accounting, auditing and other internal functions);</li>
                <li>Complying with and enforcing applicable legal requirements, relevant industry standards, contractual obligations and our policies; and For any other purposes that we may specifically disclose at the time you provide, or we collect your information.</li>
            </ul>
            <br>
            <p>We may also use data that we collect on an aggregate or anonymous basis (such that it does not identify any individual customers) for various business purposes, where permissible under applicable laws and regulations.</p>
            <br>
            <h4 class="pp-section-title">Disclosure of Information</h4>
            <br>
            <p>We may share the information we collect from and about you:</p>
            <ul>
                <li>As described in our Online Deposit Privacy Notice, including with WebBank third-party service providers;</li>
                <li>With third parties or affiliates in connection with a corporate transaction, such as a sale, consolidation or merger of WebBank businesses;</li>
                <li>With other third parties to comply with legal requirements such as the demands of applicable subpoenas and court orders; to verify or enforce our terms of use, our other rights, or other applicable policies; to address fraud, security or technical issues; to respond to an emergency; or otherwise to protect the rights, property or security of our customers or third parties; and</li>
                <li>With third parties in an anonymous or aggregated manner to help deliver products, services, and content that are tailored to you and for other purposes</li>
            </ul>
            <br>
            <h4 class="pp-section-title">Understanding Cookies, Web Beacons and Other Tracking Technologies</h4>
            <p>We, our service providers, and other companies we work with may deploy and use cookies, web beacons, local shared objects and other tracking technologies for various purposes, such as fraud prevention and monitoring our advertising and marketing campaign performance for the online deposit program. Some of these tracking tools may detect characteristics or settings of the specific device you use to access our online services.</p>
            <br>
            <p>“Cookies” are small amounts of data a website can send to a visitor's web browser. They are often stored on the device you are using to help track You areas of interest. Cookies may also enable us, our service providers, and other companies we work with to relate your use of our online services over time to customize your online experience. Most web browsers allow you to adjust your browser settings to decline or delete cookies but doing so may degrade your experience with our online services</p>
            <br>
            <p>Clear GIFs, pixel tags or web beacons—which are typically one-pixel, transparent images located on a webpage or in an email or other message—or similar technologies may be used on our sites and in some of our digital communications (such as email or other marketing messages). They may also be used when you are served advertisements concerning our online deposit products, or you otherwise interact with advertisements concerning our online deposit products outside of our website. These are principally used to help recognize users, assess traffic patterns and measure site or campaign engagement.</p>
            <br>
            <p>Local Shared Objects, sometimes referred to as “flash cookies” may be stored on your hard drive using a media player or other software installed on your device. Local Shared Objects are similar to cookies in terms of their operation but may not be managed in your browser in the same way.</p>
            <br>
            <h4 class="pp-section-title">Do Not Track</h4>
            <p>Many web browsers possess a do-not-track feature that lets your browser tell websites you visit that you do not want to have your online activities tracked. At this time, our website does not respond to browser do-not-track signals.</p>
            <br>
            <h4 class="pp-section-title">Linking to Third-Party Websites</h4>
            <p>WebBank may provide links to websites that are owned or operated by others ("third-party websites"). When you use a link online to visit a third-party website, you will be subject to that website's privacy and security practices, which may differ from ours. You should familiarize yourself with the privacy notice/policy, terms of use and security practices of the linked third-party website before providing any information on that website.</p>
            <br>
            <h4 class="pp-section-title">Security</h4>
            <p>To protect your personal information from unauthorized access and use, we use security measures that comply with federal law. These measures include computer safeguards and secured files and buildings. You can learn more about some of the steps we take to protect your personal information and steps you can take to protect your security on our [Online Deposit Security] webpage.</p>
            <br>
            <p>Please note that information you send to us electronically may not be secure when it is transmitted to us. We recommend that you do not use unsecure channels to communicate sensitive or confidential information (such as your Social Security number or account number) to us.</p>
            <br>
            <h4 class="pp-section-title">Minors</h4>
            <p>Our online deposit products are not for persons under 18 years of age and our website is not intended for persons under 18 years of age. We do not knowingly collect personal information from persons under 18 years of age.</p>
            <br>
            <h4 class="pp-section-title">Updating Your Online Deposit Account Information</h4>
            <p>Keeping your account information up-to-date is very important</p>
            <br>
            <p>You may review or update certain online deposit account information by logging in and accessing our Online Banking Portal. If you cannot change the incorrect information online, or you prefer to request changes offline, please call us at 1-844-994-BANK (2265).</p>
            <br>
            <h4 class="pp-section-title">Accessing Our Website from Outside the U.S.</h4>
            <p>Our website is intended for a U.S. audience. If you visit our website, your information will be transferred to or processed in the United States.</p>
            <br>
            <h4 class="pp-section-title">Changes to this Online Deposit Privacy Policy</h4>
            <p>We may change this Online Deposit Privacy Policy from time to time. When we do, we will let you know by appropriate means such as by posting the revised policy on this page with a new “Last Updated” date. Any changes to this Online Deposit Privacy Policy will become effective when posted or otherwise provided to you unless indicated otherwise.</p>
            <br>
            <h4 class="pp-section-title">Questions</h4>
            <p>If you have questions about our privacy practices, please contact us at 1-844-994 BANK (2265).</p>
            <h4 class="pp-section-title">California Privacy Notice</h4>
            <p>If you are a California resident who is a natural person, the California Consumer Privacy Act (“CCPA”) provides certain rights concerning your personal information, unless an exception applies. These exceptions include information collected, used, and disclosed pursuant to the Gramm-Leach-Bliley Act (“GLBA”) or the Fair Credit Reporting Act (“FCRA”). Further, the CCPA does not consider information to be personal information if it cannot be reasonably linked to any consumer or household.</p>
            <br>
            <p>If you are a current or former online deposit customer or applicant, WebBank's collection and use of your personal information is pursuant to the GLBA and FCRA, and, therefore, the CCPA does not apply. If you are otherwise a consumer that interacted or viewed one of our digital advertising campaigns for the online deposit program, we do not collect information in a manner that can be reasonably linked to you, and, therefore, the CCPA does not apply.</p>
            <br>
            <p>[WebBank does not and will not sell personal information it collects in connection with its online deposit program to third parties.]</p>
            <br>
            <br>

            <h4 class="pp-title has-text-primary">CALIFORNIA EMPLOYEE PRIVACY POLICY</h4>
            <br>
    <p>WebBank and its affiliated entities (“Bank”) are committed to respecting your privacy
    and protecting your personal information. This California Employee Privacy Policy
    applies to any of our employees, contractors, job applicants, prospective employees,
    and former employees who are California residents and about whom we have collected
    personal information for employment-related purposes only, including in the course of
    employment or application for employment with us (collectively, “<strong>you</strong>”).</p>
    <br>
    <p>To learn more about our privacy practices with respect to personal information collected
    about consumers and other individuals for purposes unrelated to employment, please
    refer to our <a @click="scrollToSection('start')">Privacy Policy</a>.</p>
    <br>
    <p>We provide this California Employee Privacy Policy to comply with applicable privacy
    laws, including the California Consumer Privacy Act of 2018 and as amended by the
    California Privacy Rights Act of 2020 (together, the “<strong>CCPA</strong>”). The CCPA provides
    California residents with rights to receive certain disclosures regarding the collection,
    use, and sharing of personal information, as well as rights to access, correct, delete,
    and restrict the sale, use, and disclosure of certain personal information we collect
    about them, unless exceptions apply. California residents also have the right not to
    receive discriminatory treatment by us for the exercise of your privacy rights under the
    CCPA. If you are a California resident, you may submit a request to exercise these
    rights by calling us at 1-884-994-BANK (2265), or emailing us at
    WebBankHR@webbank.com, or completing our online webform] using the information
    provided in the <a @click="scrollToSection('section-ca-privacy')">Your Privacy Rights</a> section below.</p>
    <br>
    <p>For the purposes of this California Employee Privacy Policy, except where a different
    definition is noted, “<strong>personal information</strong>” means information that identifies, relates to,
    describes, is reasonably capable of being associated with, or could reasonably be
    linked, directly or indirectly, with a particular California resident or household. Personal
    information does not include publicly available information; lawfully obtained, truthful
    information that is a matter of public concern; information that has been de-identified or
    aggregated; or other information covered by certain sector-specific privacy laws, as
    consistent with state law. Any capitalized term used and not otherwise defined below
    has the meaning assigned to it in our <strong>Privacy Policy</strong>.</p>
    <br>
    <p>If you are a visually impaired individual, an individual with another disability, or an
    individual seeking support in another language, you may access this California
    Employee Privacy Policy by emailing us at WebBankHR@webbank.com.</p>
        <br>
    <h4 class="pp-section-title">1. Personal Information We Collect</h4>
    <p>Bank may collect, or has collected, the following categories of personal information over
    the past twelve (12) months:</p>
    <ol type="a">
        <li><strong>Identifiers</strong>, which includes first and last name; home address; personal email
    address; telephone number; employee or personnel number; other account or
    user identification information; driver’s license information; license plate
    information; and emergency contact details.</li>
        <li><strong>Professional or employment-related information</strong>, which includes job
    application details; current employment; employment history; salary, wages, and
    other compensation data; benefits and entitlement data; bonus payments and
    amounts; company or entity; business unit or division; employment contract
    information; employment start date; employment end date; hours of work; job title
    or role; manager/supervisor; office location; employee key card or access card
    use data; travel booking details; travel history; performance ratings; professional
    memberships; background check references and related information; military
    service records and related documentation; vehicle make and model; and any
    disciplinary action and/or reason for termination.</li>
        <li><strong>Education information</strong>, which includes academic transcripts; awards or honors;
    degrees earned; education and training history; grades; languages spoken; and
    other qualifications and certifications.</li>
        <li><strong>Personal information described in California Civil Code § 1798.80(e)</strong>, which
    includes bank account numbers, credit or debit card numbers, and other financial
    information; insurance policy numbers, medical conditions, workplace
    accommodations and related documentation, FMLA calculations and related
    leave records, worker’s compensation claim information, and other medical and
    health insurance information.</li>
        <li><strong>Characteristics protected under California or federal law</strong>, which includes
    your date of birth, age, or age range; criminal history; criminal records; disability
    status; drug test results; gender or gender identity; income level; marital status;
    military or veteran status; nationality; pregnancy status; racial or ethnic origin;
    sexual orientation; trade union membership; as well as similar information about
    your household members and dependents.</li>
        <li><strong>Internet or other electronic network activity information</strong>, which includes
    cookie identifiers, your computer’s operating system.</li>
        <li><strong>Geolocation data, Audio, electronic, visual, thermal, olfactory, or similar
    information</strong>.</li>
        <li><strong>Inferences</strong> drawn from the personal information listed above.</li>
    </ol>
    <br>
    <p>Please note that because of the overlapping nature of certain of the categories of
    personal information identified above, which are required by state law, some of the
    personal information we collect may be reasonably classified under multiple categories.</p>
        <br>
    <p><strong>Sensitive personal information</strong>. Certain of the personal information that we collect,
    as described above, may constitute “sensitive personal information” under California
    law, including:</p>
    <ul>
        <li>Social Security number, driver’s license, state identification card, or passport
    number</li>
    </ul>
    <br>
        <h4 class="pp-section-title">2. Sources of Personal Information</h4>
    <p>We may collect personal information about you from the following categories of sources:</p>
    <ul>
        <li><strong>From you</strong>, including from your employment application and/or over the course of
    your employment, such as in-person or via email, telephone, electronic
    messaging, postal mail, social media, or other means.</li>
        <li><strong>From other individuals</strong>, including recruiters and temporary job placement
    agencies, and our other employees and contractors.</li>
        <li><strong>From our service providers</strong>, including providers of background checks and
    credit checks; communications and analytics providers; internet service
    providers; operating systems and platforms; data brokers; and fraud solutions.</li>
        <li><strong>From government entities</strong>, to assist in providing employee benefits and
    services to you.</li>
    </ul>
    <p>We may supplement the information described above with information we obtain from
    other sources, including from both online and offline data providers.</p>
    <br>
    <h4 class="pp-section-title">3. How We Use Your Personal Information</h4>
    <p>We may use the personal information we collect from you for the following purposes:</p>
    <ul>
        <li>To facilitate employment and internship applications, including conducting
        screenings, interviews, and background checks.</li>
        <li>To facilitate employee training.</li>
        <li>To communicate with our employees.</li>
        <li>To manage our workforce, including to complete performance reviews,
        evaluations, and internal investigations.</li>
        <li>To administer payroll and benefits to our employees and their dependents.</li>
        <li>To provide you with services, products, discounts, and other benefits related to
        your status as an employee.</li>
        <li>To operate our systems, including IT, maintenance, and security.</li>
        <li>To limit, protect, or otherwise restrict physical access to our offices and facilities,
        including areas with sensitive data.</li>
        <li>To maintain and improve the quality of our employee sites, services, and
        benefits.</li>
        <li>To grow our business, including to perform research and development, and
        understand the effectiveness of our marketing.</li>
        <li>To ensure legal compliance, manage risk, and audit our business, including to
        respond to subpoenas, court orders, and legal process, or to establish or
        exercise our legal rights or defend against legal claims; and</li>
        <li>To meet our obligations for taxes and other government filing requirements.</li>
    </ul>
    <p>The sensitive personal information that we collect as described in Section 1 above may
    be used for any of the above purposes.</p>
    <br>
    <p>We will retain personal information for as long as needed or permitted in light of the
    purpose(s) for which it was obtained. The criteria used to determine our retention
    periods include: (i) the length of time we have an ongoing relationship with you; (ii)
    whether there is a legal obligation to which we are subject; (iii) whether there is a
    privacy right for which the personal information has been exercised (such as a request
    to delete); and (iv) whether retention is advisable in light of our legal position (such as in
    regard to applicable statutes of limitations, litigation or regulatory investigations).</p>
    <br>
    <h4 class="pp-section-title">4. Who We Disclose Your Personal Information To</h4>
    <p>We do not sell or share your personal information as those terms are defined under
    California law. We may disclose your personal information with the following categories
    of service providers and third parties:</p>
    <ul>
        <li><strong>Our other employees</strong>. We may disclose your personal information with our
        other employees consistent with the purposes identified in Section 2 above.</li>
        <li><strong>Our affiliates</strong>. We may disclose your personal information with our affiliates
        consistent with the purposes identified in Section 2 above.</li>
        <li><strong>Service providers</strong>. We may disclose your personal information with our service
        providers to provide services on our behalf, such as providers of background and
        credit checks, HR and payroll processing, analytics, hosting, technical support,
        and other services. These third parties have access to your personal information
        only to perform these tasks on our behalf and are obligated not to disclose or use
        the information for any other purpose.</li>
        <li><strong>Affiliate and business transfer</strong>. If Bank is involved in a merger, acquisition or
        asset sale, your personal information may be transferred. We will provide notice
        before your personal information is transferred and becomes subject to a
        different privacy policy.</li>
        <li><strong>Legal compliance and harm prevention</strong>. We may disclose your personal
        information as we believe necessary (i) to comply with applicable law, rules and
        regulations; (ii) to enforce our contractual rights; (iii) to investigate possible
        wrongdoing in connection with our company; (iv) to protect and defend the rights,
        privacy, safety and property of Bank, you or others; and (v) to respond to
        requests from courts, law enforcement agencies, regulatory agencies, and other
        public and government authorities.</li>
    </ul>
    <br>
    <h4 class="pp-section-title">5. Your Privacy Rights</h4>
    <p>If you are a California resident, you have the right to make the following requests under
    applicable California law in relation to your personal information, subject to certain
    exceptions:</p>
    <ul>
        <li><strong>Right to Know</strong>. You have the right to, up to twice in a 12-month period, request
        what personal information we collect, use, disclose, and/or sell, and to whom, as
        applicable.</li>
        <li><strong>Right to Delete</strong>. You have the right to request, under certain circumstances, the
        deletion of your personal information that we collect.</li>
        <li><strong>Right to Opt-Out of Sale or Sharing</strong>. You have the right to opt-out of the sale
        or sharing of your personal information as those terms are defined under
        California law. Please note that Bank does not currently sell or share personal
        information that is subject to this California Employee Privacy Policy.</li>
        <li><strong>Right to Non-Discrimination</strong>. You have the right not to receive discriminatory
        treatment for the exercise of the privacy rights described above.</li>
        <li><strong>Right to Limit Use and Disclosure</strong>. You have the right to limit the use or
        disclosure of your sensitive personal information to only the uses necessary for
        us to provide employment-related services to you. We will not use or disclose
        your sensitive personal information after you have exercised your rights unless
        you subsequently provide consent for the use of your sensitive personal
        information for additional purposes.</li>
        <li><strong>Right to Correct</strong>. You have the right to request the correction of your inaccurate
        personal information.</li>
    </ul>
    <p><strong>How to submit a request</strong>. You may exercise any of the rights described in this section
    by emailing us at WebBankHR@webbank.com, or by calling <strong>1-884-994-BANK (2265)</strong>.</p>
    <br>
    <p>Any request you submit to us is subject to an identification and residency verification
    process (“<strong>Verifiable Consumer Request</strong>”) as permitted by the CCPA. We will not fulfill
    your request unless you have provided sufficient information that enables us to
    reasonably verify that you are the consumer about whom we collected the personal
    information on. To verify you, you must provide us with first name, last name, and email
    address. These rights are also subject to various exclusions and exceptions under
    applicable laws.</p>
        <br>
    <p>You may also designate an authorized agent, in writing or through a power of attorney,
    to request to exercise the above rights on your behalf.  If you should use an authorized
    agent to exercise your various rights under the CCPA, we may require that you provide
    your authorized agent with written permission to exercise your various rights and to
    verify your own identity with us. If your authorized agent does not submit proof that they
    have been authorized by you to submit verified requests for disclosure and deletion, we
    reserve the right to deny such a request that we have received and will explain to your
    authorized agent why we have denied such request. The authorized agent may submit
    a request to exercise these rights by emailing the letter of authorization or power of
    attorney to WebBankHR@webbank.com.</p>
    <br>
    <p>We currently do not collect household data. If we receive a request submitted by all
    members of a household, we will individually respond to each request. We will not be
    able to comply with any request by a member of a household under the age of 13, as
    we do not collect personal information from any person under the age of 13.</p>
    <br>
    <p>We will respond to your request within forty-five (45) days after receipt of a Verifiable
    Consumer Request for a period covering twelve (12) months and for no more than twice
    in a twelve-month period. We reserve the right to extend the response time by an
    additional forty-five (45) days when reasonably necessary and provided consumer
    notification of the extension is made within the first forty-five (45) days.</p>
    <br>
    <h4 class="pp-section-title">6. Contact Us</h4>
    <p>If you have any questions about this California Employee Privacy Policy or wish to
    exercise one of your privacy rights, please contact us using the following information:</p>
    <br>
    <div class="columns">
        <div class="column is-offset-2">

            <p><strong>WebBank</strong></p>
            <table>
                <tbody>
                    <tr>
                        <td><strong>Email:</strong></td>
                        <td>WebBankHR@webbank.com</td>
                    </tr>
                    <tr>
                        <td><strong>Phone:</strong></td>
                        <td>1-884-994-BANK (2265)</td>
                    </tr>
                    <tr>
                        <td><strong>Mail:</strong></td>
                        <td>
                            <address>
                                215 S. State St.<br>
                                Suite 1000<br>
                                Salt Lake City, UT 84111
                            </address>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <br>
    <p><em>Last Updated: June 2023</em></p>
                    </div>
                </div>
            </div>
        </div>
    </section>

</template>

<script>
export default {

    created() {
        document.title = "Privacy - WebBank";
    },

    methods: {
        scrollToSection: function (section) {
            let e = document.getElementById(section);
            e.scrollIntoView({
                block: 'start',
                behavior: 'smooth',
                inline: 'start'
            });
        },
    }

}
</script>

<style scoped>
.pp-title {
    font-size: 1.5rem;
    border-bottom: 1px solid black;
    margin-bottom: 25px;
    padding-bottom: 10px;
    font-weight: bold;
}
.pp-section-title {
    font-size: 1.25rem;
}
</style>
